<template>
  <div>
    <p><b><u>Your current RES details with the associated EA (if applicable)</u></b></p>
    <br />
    <b-field class="xb-input" horizontal label="RES Name">
      <span>{{ resInformation.name || "-" }}</span>
    </b-field>

    <b-field class="xb-input" horizontal label="Alias/Business Name">
      <span>{{ resInformation.businessName || "-" }}</span>
    </b-field>

    <b-field class="xb-input" horizontal label="Registration No.">
      <span
        >{{ resInformation.applicationNo || "-" }}
        {{ resInformation.isWatchlistStatusSuspended }}</span
      >
    </b-field>

    <b-field class="xb-input" horizontal label="Registration Start Date">
      <span>{{
        resInformation.validityDateStart &&
        resInformation.validityDateStart.length > 0
          ? $_globalMixin_displaySGT(
              resInformation.validityDateStart,
              "dd/MM/yyyy"
            )
          : "-"
      }}</span>
    </b-field>

    <b-field class="xb-input" horizontal label="Registration End Date">
      <span>{{
        resInformation.validityDateEnd &&
        resInformation.validityDateEnd.length > 0
          ? $_globalMixin_displaySGT(
              resInformation.validityDateEnd,
              "dd/MM/yyyy"
            )
          : "-"
      }}</span>
    </b-field>

    <b-field class="xb-input" horizontal label="EA Name">
      <span>{{ eaInformation.name }}</span>
    </b-field>

    <b-field class="xb-input" horizontal label="EA Licence No.">
      <span>{{ eaInformation.licenseNo }}</span>
    </b-field>

    <b-field class="xb-input" horizontal label="EA Licence Start Date">
      <span>{{
        eaInformation.validityDateStart &&
        eaInformation.validityDateStart.length > 0
          ? $_globalMixin_displaySGT(
              eaInformation.validityDateStart,
              "dd/MM/yyyy"
            )
          : "-"
      }}</span>
    </b-field>

    <b-field class="xb-input" horizontal label="EA Licence End Date">
      <span>{{
        eaInformation.validityDateEnd &&
        eaInformation.validityDateEnd.length > 0
          ? $_globalMixin_displaySGT(
              eaInformation.validityDateEnd,
              "dd/MM/yyyy"
            )
          : "-"
      }}</span>
    </b-field>
  </div>
</template>

<script>
const mapState = window.Vuex.mapState;

export default {
  name: "RESDetailedInformation",
  data() {
    return {
      eaInformation: {
        licenseNo: "-",
        name: "-",
        validityDateEnd: null,
        validityDateStart: null
      }
    };
  },
  computed: {
    ...mapState({
      apiConfig: state => state.config.configurationData,
      accessToken: state => state.auth.accessToken,
      userProfileAdditionalInfo: state =>
        state.header.userProfile.additionalProfileInfo
    }),
    resInformation() {
      return {
        name: this.userProfileAdditionalInfo?.name,
        businessName: this.userProfileAdditionalInfo?.profileDetailDto
          ?.generalInfoJson?.businessName,
        applicationNo: this.userProfileAdditionalInfo?.applicationNo,
        validityDateStart: this.userProfileAdditionalInfo?.validityDateStart,
        validityDateEnd: this.userProfileAdditionalInfo?.validityDateEnd,
        isWatchlistStatusSuspended:
          `${this.userProfileAdditionalInfo?.watchlistStatus}`.toLowerCase() ===
          "suspended"
            ? "(Suspended)"
            : null
      };
    }
  },
  mounted() {
    this.getLicenceNumber();
  },
  methods: {
    getLicenceNumber() {
      const endpoint = this.apiConfig.common_module.profileManagement
        .getProfileBySgid;

      this.$api.post(endpoint, {}, this.fetchDetailedInformation, () => {}, {
        redirection: false
      });
    },
    fetchDetailedInformation(response) {
      const data = response.data.data;

      const endpoint = this.apiConfig.common_module.profileManagement
        .getOverviewData;

      const payload = {
        sgId: data.sgId
      };
      this.$api.post(
        endpoint,
        payload,
        this.handleFetchDetailInformationSuccess,
        () => {},
        { redirection: false }
      );
    },
    handleFetchDetailInformationSuccess(response) {
      const data =
        response.data.data.ea && response.data.data.ea.length > 0
          ? response.data.data.ea[0]
          : {};
      this.eaInformation = { ...this.eaInformation, ...data };
    }
  }
};
</script>

<style></style>
